import { useState, useEffect } from "react";
import { callBackend } from "../components/callBackend";
import { Container, Table, Nav } from "react-bootstrap";
import DataTable from "../components/DataTable";
import DownloadButton from "../components/DownloadButton";
import Loader from "../components/Loader"; // 1. Import the Loader

export default function AllSAReg() {
    const [count, setCount] = useState(0);
    const [SAData, setSAData] = useState([]);
    // 2. Add isLoading state, initialized to true
    const [isLoading, setIsLoading] = useState(true);
    const [view, setView] = useState("list");
    const [leaderboard, setLeaderboard] = useState([]);
    const [lbLoading, setLbLoading] = useState(false);

    let pref = JSON.parse(localStorage.getItem("nssc-admin-pref"));
    const [tableControls, setTableControls] = useState(
        pref && pref.pageID == 2 && pref.v === 2
            ? pref
            : {
                  page: 1,
                  length: 100,
                  sortField: "_id",
                  sortDir: -1,
                  search: "",
              }
    );

    const columns = {
        _id: "Serial Number",
        saID: "SA ID",
        fName: "First Name",
        lName: "Last Name",
        email: "Email",
        phone: "Phone",
        college: "College/School",
        city: "City",
        state: "State/UT",
        gender: "Gender",
        count: "Registrations",
        paidCount: "Payments",
    };

    let downloadHeaders = [
        { label: "SA ID", key: "saID" },
        { label: "First Name", key: "fName" },
        { label: "Last Name", key: "lName" },
        { label: "Email Address", key: "email" },
        { label: "Phone Number", key: "phone" },
        { label: "Gender", key: "gender" },
        { label: "Age", key: "age" },
        { label: "Level of Study", key: "level" },
        { label: "Name of Institution", key: "college" },
        { label: "City", key: "city" },
        { label: "State/UT", key: "state" },
        { label: "Registrations", key: "count" },
        { label: "Payments", key: "paidCount" },
        { label: "PIDs", key: "pids" },
    ];

    // 3. Update useEffect to manage the loading state
    useEffect(() => {
        if (!localStorage.getItem("nssc-admin-token")) {
            window.location.href = "/login";
            return;
        }
        setIsLoading(true); // Show loader for every fetch
        callBackend({
            method: "GET",
            endpoint: "/admin/sa/selected",
            data:
                "sortField=" +
                tableControls.sortField +
                "&sortDir=" +
                tableControls.sortDir +
                "&first=" +
                (0 + tableControls.length * (tableControls.page - 1)) +
                "&limit=" +
                tableControls.length +
                "&search=" +
                encodeURIComponent(tableControls.search || ""),
            onSuccess: (res) => {
                setSAData(res.data);
                setCount(res.count);
                setIsLoading(false); // Hide loader on success
            },
            onError: (error) => {
                console.error("Failed to fetch SA data:", error);
                setIsLoading(false); // Hide loader on error
            },
        });
        localStorage.setItem(
            "nssc-admin-pref",
            JSON.stringify({ ...tableControls, pageID: 2, v: 2 })
        );
    }, [tableControls]);

    useEffect(() => {
        if (view !== "leaderboard") return;
        callBackend({
            method: "GET",
            endpoint: "/admin/sa/leaderboard",
            setLoading: setLbLoading,
            onSuccess: (res) => setLeaderboard(res.data || []),
        });
    }, [view]);

    return (
        <Container
            fluid
            style={{
                marginTop: "20px",
                marginBottom: "20px",
            }}
        >
            <h1>Student Ambassadors</h1>

            <Nav variant="tabs" activeKey={view} onSelect={setView} className="mb-3">
                <Nav.Item>
                    <Nav.Link eventKey="list">All Selected</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="leaderboard">Leaderboard</Nav.Link>
                </Nav.Item>
            </Nav>

            {view === "leaderboard" ? (
                lbLoading ? (
                    <Loader />
                ) : (
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>SA ID</th>
                                <th>Name</th>
                                <th>College/School</th>
                                <th>City</th>
                                <th>Paid Registrations</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leaderboard.map((sa) => (
                                <tr key={sa.saID}>
                                    <td>{sa.rank}</td>
                                    <td>{sa.saID}</td>
                                    <td>{sa.name}</td>
                                    <td>{sa.college}</td>
                                    <td>{sa.city}</td>
                                    <td>{sa.registrations}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )
            ) : isLoading ? (
                <Loader />
            ) : (
                <DataTable
                    columns={columns}
                    data={SAData}
                    count={count}
                    tableControls={tableControls}
                    setTableControls={setTableControls}
                    downloadButton={
                        <DownloadButton
                            endpoint={"/admin/download/sa/"}
                            downloadHeaders={downloadHeaders}
                        />
                    }
                />
            )}
        </Container>
    );
}